<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="add-refund-btn">
  <button mat-fab color="primary" matTooltip="Kreiraj Odluku o povratu" (click)="goToCreateRefund()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="refunds-container">
  @for (refund of filteredRefunds; track refund) {
    <div class="col-lg-4 col-md-6 refund-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Klasa:</strong> {{ refund.classificationCode }}</p>
          <p><strong>Urudžbeni broj:</strong> {{ refund.referenceNumber }}</p>
          <p><strong>Datum Odluke o povratu:</strong> {{ refund.date | date: 'd.M.yyyy.' }}</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj stavke povrata" (click)="goToViewRefund(refund)">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Uredi Odluku o povratu" (click)="goToEditRefund(refund)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="primary" matTooltip="Preuzmi Odluku o povratu" (click)="downloadRefund(refund)">
            <mat-icon>download</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Obriši Odluku o povratu" (click)="confirmDelete(refund)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>